import { render } from "./scheduling.vue?vue&type=template&id=4b212502&scoped=true&ts=true"
import script from "./scheduling.vue?vue&type=script&lang=ts"
export * from "./scheduling.vue?vue&type=script&lang=ts"

import "./scheduling.vue?vue&type=style&index=0&id=4b212502&lang=less&scoped=true"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b212502"]])

export default __exports__